import React from 'react';
import Reflux from 'reflux';
import { Row, Col, Button } from 'bootstrap';
import ModalActions from 'flux/actions/ModalActions';
import UIRegions from 'shared/constants/UIRegions';
import WordExportFormStore from 'flux/stores/WordExportFormStore';
import EventViewStore from 'flux/stores/EventViewStore';
import CuesheetStore from 'flux/stores/cuesheet/CuesheetStore';
import WordExportFormActions from 'flux/actions/WordExportFormActions';
import classnames from 'classnames';
import { ToggleSwitch } from '@shoflo-rundown/polymer.legacy';
import { WithTooltip } from '@shoflo-rundown/polymer.legacy';
import _ from 'underscore';
import s3Urls from 'shared/constants/s3';
import TooltipConstants from 'shared/constants/TooltipConstants.jsx';
import { fontSizes } from 'shared/constants/WordExportConstants.js';
import { truncate } from 'underscore.string';
import HeroFontSizeMenu from 'shared/components/menus/heroFontSize';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

class WordExportFormStateless extends React.Component {
  constructor(props) {
    super(props);
    this._getFixedToggleOptions = this._getFixedToggleOptions.bind(this);
    this._getColumnToggleOptions = this._getColumnToggleOptions.bind(this);
    this._getExampleNode = this._getExampleNode.bind(this);
    this._submit = this._submit.bind(this);
  }

  render() {
    let { form } = this.props;
    if (!form.get('fullColumns') || !form.get('columns')) return null;
    return (
      <Row>
        <Col md={8} lg={8}>
          <h3>Settings</h3>
          <div className="pull-left">
            <h6>Columns</h6>
          </div>
          <div className="pull-right">
            <h6>Visibility</h6>
          </div>
          <div className="clearfix" />
          {this._getFixedToggleOptions()}
          {this._getColumnToggleOptions()}

          <div className="text-center">
            <Button className="download-word-btn" onClick={this._submit}>
              Download Script
            </Button>
          </div>
        </Col>
        <Col md={16} lg={16} className="text-center">
          {this._getExampleNode()}
        </Col>
      </Row>
    );
  }

  _getFixedToggleOptions() {
    const { show, form } = this.props;

    const fields = {
      displayItemNumbers: 'Item Numbers',
      displayItemTitles: 'Item Titles',
      displayItemDescriptions: 'Item Descriptions',
      displayDuration: 'Duration',
      displayPresetDuration: 'Preset Time',
      displayStartTime: 'Start Time',
    };

    const toggleNodes = _.map(fields, (v, k) => {
      if (!show.has(k) && !form.has(k)) return null;
      return (
        <SettingsToggleNode
          name={v}
          field={k}
          visible={form.get(k) !== false}
        />
      );
    }).filter((n) => n);

    return <div>{toggleNodes}</div>;
  }

  _getColumnToggleOptions() {
    let { form } = this.props;

    let toggleNodes = form.get('fullColumns').map((col) => {
      let title = col.get('title');
      let colId = col.get('_id');

      return (
        <ColumnToggleNode
          name={title}
          colId={colId}
          heroColId={form.get('heroField')}
          visible={form.getIn(['columns', colId])}
          skipEmpty={form.get('skipEmptyHeroFields')}
        />
      );
    });

    return <div>{toggleNodes}</div>;
  }

  _getExampleNode() {
    return <ExampleNode {...this.props} />;
  }

  _submit() {
    ModalActions.hide(UIRegions.WordExportForm);

    WordExportFormActions.submit();
  }
}

/**
 * Simple toggle node
 *
 * @param name
 * @param field
 * @param visible
 * @returns {XML}
 * @constructor
 */
const SettingsToggleNode = ({ name, field, visible }) => {
  return (
    <div className={classnames('clearfix word-export-column')}>
      <span className="pull-left">{truncate(name, 20)}</span>
      <span className="pull-right">
        <ToggleSwitch
          on={visible}
          onClick={() =>
            WordExportFormActions.updateField(field, visible ? false : true)
          }
        />
      </span>
    </div>
  );
};

/**
 * Simple toggle node
 *
 * @param heroColId
 * @param name
 * @param colId
 * @param visible
 * @param skipEmpty
 * @returns {XML}
 * @constructor
 */
const ColumnToggleNode = ({ heroColId, name, colId, visible, skipEmpty }) => {
  let skipEmptyNode = null;

  const heroNode = (
    <WithTooltip
      placement="top"
      delay={1000}
      tip={TooltipConstants.WordExportHeroColumnExplanation}
    >
      <span className="hero-input-wrapper">
        <input
          type="radio"
          checked={heroColId === colId}
          onClick={() => {
            WordExportFormActions.updateField('heroField', colId);
            WordExportFormActions.updateColumn(colId, true);
          }}
        />
        &nbsp; hero
      </span>
    </WithTooltip>
  );

  if (heroColId === colId) {
    skipEmptyNode = (
      <div className="word-export-skip-empty-hero">
        <div className="word-export-skip-empty-hero-text">
          Skip rows with no hero content?
        </div>
        <div>
          <span className="hero-input-wrapper word-export-skip-empty-hero-yes">
            <input
              type="radio"
              checked={skipEmpty}
              onClick={() => {
                WordExportFormActions.updateField(
                  'skipEmptyHeroFields',
                  !skipEmpty,
                );
              }}
            />
            &nbsp; Yes
          </span>
          <span className="hero-input-wrapper word-export-skip-empty-hero-no">
            <input
              type="radio"
              checked={!skipEmpty}
              onClick={() => {
                WordExportFormActions.updateField(
                  'skipEmptyHeroFields',
                  !skipEmpty,
                );
              }}
            />
            &nbsp; No
          </span>
        </div>
      </div>
    );
  }

  return (
    <div
      className={classnames('clearfix word-export-column', {
        'word-export-column-active': heroColId === colId,
      })}
    >
      <span className="pull-left">{truncate(name, 20)}</span>
      <span className="pull-right">
        {heroNode}
        <ToggleSwitch
          on={visible}
          onClick={() =>
            WordExportFormActions.updateColumn(colId, visible ? false : true)
          }
        />
      </span>
      <div>{skipEmptyNode}</div>
    </div>
  );
};

/**
 * Example Node pure component
 *
 */
const ExampleNode = ({ form, show, eventTitle }) => {
  const fullColumns = form.get('fullColumns');

  const className = 'word-export-preview-label';

  const Label = ({ children }) => <span className={className}>{children}</span>;
  const BoldLabel = ({ children }) => (
    <span className={className}>
      <strong>{children}</strong>
    </span>
  );
  const FieldRow = ({ children }) => (
    <div className={className}>{children}</div>
  );

  const RowLeftAlign = ({ children, colProps }) => {
    return (
      <Row>
        <Col lg={24} {...colProps} className="text-left">
          {children}
        </Col>
      </Row>
    );
  };

  let heroColumn = null;
  const columnNodes = fullColumns.map((col) => {
    const title = col.get('title');
    const colId = col.get('_id');
    const fieldEnabled = form.getIn(['columns', colId]) === true;
    const isHero = colId === form.get('heroField');

    if (isHero && fieldEnabled) {
      heroColumn = col;
    }

    if (!fieldEnabled || isHero) return null;

    return (
      <RowLeftAlign>
        <FieldRow>{title}</FieldRow>
      </RowLeftAlign>
    );
  });

  let heroNode = null;

  if (heroColumn) {
    heroNode = (
      <RowLeftAlign>
        <FieldRow>
          <div className="word-export-preview-hero">
            <div className="word-export-preview-hero-title">
              {heroColumn.get('title')} (Hero)
            </div>
            <div className="word-export-preview-hero-font-size">
              <span className="word-export-preview-hero-font-size-title">
                Hero text size:
              </span>
              <span className="word-export-preview-hero-font-size-menu">
                <HeroFontSizeMenu
                  items={fontSizes}
                  activeItem={form.get('heroFontSize')}
                  onChange={(key) =>
                    WordExportFormActions.updateField('heroFontSize', key)
                  }
                />
              </span>
            </div>
            <h6>
              <em>{TooltipConstants.WordExportHeroColumnExplanation}</em>
            </h6>
          </div>
        </FieldRow>
      </RowLeftAlign>
    );
  }

  let style = {
    backgroundImage: `url(${s3Urls.scriptExportGraphic})`,
  };

  return (
    <div className="word-export-form-preview" style={style}>
      <RowLeftAlign colProps={{ lg: 12 }}>
        <div className="event-title`">{eventTitle}</div>
        <div className="show-title">{show.get('title')}</div>
        <hr />
      </RowLeftAlign>

      <RowLeftAlign>
        {show.get('displayItemNumbers') && form.get('displayItemNumbers') && (
          <BoldLabel>Item #</BoldLabel>
        )}
        {show.get('displayItemTitles') && form.get('displayItemTitles') && (
          <BoldLabel>Item Title</BoldLabel>
        )}
      </RowLeftAlign>

      <RowLeftAlign>
        {show.get('displayItemDescriptions') &&
          form.get('displayItemDescriptions') && (
            <FieldRow>Item Description</FieldRow>
          )}
      </RowLeftAlign>

      <RowLeftAlign>
        {show.get('displayStartTime') && form.get('displayStartTime') && (
          <Label>Start Time</Label>
        )}
        {show.get('displayPresetDuration') &&
          form.get('displayPresetDuration') && <Label>Preset Time</Label>}
        {show.get('displayDuration') && form.get('displayDuration') && (
          <Label>Duration</Label>
        )}
      </RowLeftAlign>

      {columnNodes}

      {heroNode}

      <em>
        NOTE: Your actual export will visually look different. This is just a
        visualization of the layout.
      </em>
    </div>
  );
};

/**
 * A wrapper that injects state
 */
export default React.createClass({
  displayName: 'WordExportForm',

  mixins: [
    Reflux.connect(WordExportFormStore, 'form'),
    Reflux.connectFilter(EventViewStore, 'eventTitle', (st) => st.get('title')),
    Reflux.connectFilter(CuesheetStore, 'show', (state) => state.get('show')),
  ],

  render() {
    return (
      <div>
        <WordExportFormStateless {...this.state} />
      </div>
    );
  },
});
